import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30d07872"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "block w-full" }
const _hoisted_2 = { class: "contentHeader flex" }
const _hoisted_3 = { class: "text-grey ml-2 mt-1.5" }
const _hoisted_4 = { class: "contentBox" }
const _hoisted_5 = { class: "inputGroup grid grid-cols-2 gap-4 w-full mt-2 mb-6" }
const _hoisted_6 = { class: "detailRegion" }
const _hoisted_7 = { class: "flex locationDetailRow" }
const _hoisted_8 = { class: "detailAttribute" }
const _hoisted_9 = { class: "flex locationDetailRow" }
const _hoisted_10 = { class: "detailAttribute" }
const _hoisted_11 = { class: "flex locationDetailRow" }
const _hoisted_12 = { class: "detailAttribute" }
const _hoisted_13 = { class: "flex locationDetailRow" }
const _hoisted_14 = { class: "detailAttribute" }
const _hoisted_15 = { class: "flex locationDetailRow" }
const _hoisted_16 = { class: "detailAttribute" }
const _hoisted_17 = { class: "flex locationDetailRow" }
const _hoisted_18 = { class: "detailAttribute" }
const _hoisted_19 = { class: "flex locationDetailRow" }
const _hoisted_20 = { class: "detailAttribute" }
const _hoisted_21 = { class: "flex locationDetailRow" }
const _hoisted_22 = { class: "detailAttribute" }
const _hoisted_23 = { class: "detailRegion" }
const _hoisted_24 = { class: "flex locationDetailRow" }
const _hoisted_25 = { class: "detailAttribute" }
const _hoisted_26 = { class: "flex locationDetailRow" }
const _hoisted_27 = { class: "detailAttribute" }
const _hoisted_28 = { class: "inputGroup grid grid-cols-2 gap-4 w-full mt-5" }
const _hoisted_29 = { class: "inputTitle" }
const _hoisted_30 = { class: "inputField flex-grow" }
const _hoisted_31 = { class: "error-msg" }
const _hoisted_32 = { class: "inputTitle" }
const _hoisted_33 = { class: "inputField flex-grow" }
const _hoisted_34 = { class: "error-msg" }
const _hoisted_35 = { class: "inputGroup grid grid-cols-2 gap-4 w-full mt-5" }
const _hoisted_36 = { class: "inputTitle" }
const _hoisted_37 = { class: "helpText" }
const _hoisted_38 = { class: "" }
const _hoisted_39 = { class: "mt-2 inline-block pseudoButton pseudoSecondary" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_41 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_42 = { class: "inputTitle" }
const _hoisted_43 = { class: "inputField flex-grow grid grid-cols-2 gap-4 w-full" }
const _hoisted_44 = { class: "relative" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-loeschen" }, null, -1))
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = ["src"]
const _hoisted_49 = { class: "text-center" }
const _hoisted_50 = { class: "inputGroup w-full mt-5" }
const _hoisted_51 = ["disabled"]
const _hoisted_52 = { class: "text-center" }

import {computed, onMounted, ref} from "vue";
import {DisdiService} from "@/utilities/services/entities/DisdiService";
import {ErrorLocationType} from "@/utilities/enums/Enums";
import {DisdiInfo} from "@/models/disdi/DisdiInfo";
import {CategoryService} from "@/utilities/services/entities/CategoryService";
import {CategoryInfo} from "@/models/category/CategoryInfo";
import Select from "@/components/inputs/Select";
import {LocationService} from "@/utilities/services/entities/LocationService";
import {LocationInfo} from "@/models/location/LocationInfo";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import DateToStringHelper from "@/utilities/helpers/DateToStringHelper";
import useVuelidate from "@vuelidate/core";
import {helpers, required} from "@vuelidate/validators";
import {$t} from "@/utilities/i18n/config";
import {useDisdiMaintenanceStore} from "@/stores/DisdiMaintenanceStore";
import NullOrUndefinedHelper from "@/utilities/helpers/NullOrUndefinedHelper";
import Error from "@/components/Error";
import router from "@/router";
import Progressbar from "@/components/Progressbar.vue";
import sleeper from "@/utilities/helpers/Sleeper";
import TextOrSpinner from "@/components/TextOrSpinner";
import ErrorHandler from "@/utilities/helpers/ErrorHandler";
import {GeneralResponse} from "@/models/api/Responses";



export default /*#__PURE__*/_defineComponent({
  __name: 'DisdiMaintenance',
  setup(__props) {

const disdiStore = useDisdiMaintenanceStore();
const disdiService = new DisdiService();
const categoryService = new CategoryService();
const locationService = new LocationService();

const currentDisdi = ref<DisdiInfo|null>(null);
const categoryList = ref<Array<CategoryInfo>|undefined>(undefined);
const contextLocation = ref<LocationInfo|null>(null);
const loading = ref<boolean>(false);
const loadingAttachments = ref<boolean>(false);
const attachmentUrlList = ref<Array<string>|null>(null);
const uploadPercentage = ref<string>("0%");
const uploadInput = ref<HTMLInputElement|null>(null);
const fileNameList = ref<Array<string>|null>(null);
const closingDisdi = ref<boolean>(false);

const regStartString = computed(()=> !NullOrUndefinedHelper(currentDisdi.value?.registrationStart)
    ? DateToStringHelper(new Date (currentDisdi.value.registrationStart))
    : "");
const regEndString = computed(()=> !NullOrUndefinedHelper(currentDisdi.value?.registrationEnd)
    ? DateToStringHelper(new Date(currentDisdi.value.registrationEnd))
    : "");

const rules = computed(() => ({
  diaryDescription: { required: helpers.withMessage($t('validators.required'), required), },
  categoryId: { required: helpers.withMessage($t('validators.required'), required), },
}));
const validator = ref(useVuelidate(rules, currentDisdi))

const changeCategoryId = (value)=>{
  currentDisdi.value.categoryId = value !== null ? value : "";
}

const uploadCallback = async (newPercentage:string)=>{
  uploadPercentage.value = newPercentage;
  if (newPercentage === "100%"){ //TODO do discuss reset behaviour!
    await sleeper(2000)
    uploadPercentage.value = "0%";
  }
}

const addImageToUploadList = async ()=>{
  //@ts-expect-error
  if(uploadInput.value ===  null || uploadInput.value.files.length === 0) return;

  const fileList = [];
  //@ts-expect-error
  for (const file of uploadInput.value.files){
    fileList.push(file)
  }

  fileNameList.value = fileList.map(f=>f.name);

  const urlList = await disdiService.getAttachementUploadUrl(currentDisdi.value?.id as string, fileList.map((f:File) => f.name), ErrorLocationType.disdiMaintenance)
  if(urlList === null) return;

  const success = await disdiService.uploadFilesToBlobStorage(urlList, fileList, ErrorLocationType.disdiMaintenance, uploadCallback);

   if(success){
    loadingAttachments.value = true;
    await sleeper(300);
    attachmentUrlList.value = await disdiService.getAttachments(currentDisdi.value?.id as string, ErrorLocationType.disdiMaintenance);
    await updateHasAttachmentProperty();
    loadingAttachments.value = false;
  }
}

const deleteAttachmentByIndex = async(url:string)=>{
  // get fileName from attachment url
  const fileName = (new URL(url)).pathname.split("/").slice(-1)[0];

  const success = await disdiService.deleteAttachmentByFileName(currentDisdi.value?.id as string, fileName, ErrorLocationType.disdiMaintenance)

  if(!success) return;

  // delete from attachment list
  attachmentUrlList.value = attachmentUrlList.value.filter(u => !u.includes(fileName));
  await updateHasAttachmentProperty();
}

const updateHasAttachmentProperty = async()=>{
  const updateHasAttachmentResp = await disdiService.checkAndUpdateHasAttachmentProperty(currentDisdi.value?.id as string);
  if (!updateHasAttachmentResp || updateHasAttachmentResp.statusCode !== 0){
    ErrorHandler.handleError(updateHasAttachmentResp as GeneralResponse, ErrorLocationType.disdiMaintenance);
  }
}

const closeDisdi = async ()=>{
  const isValid = await validator.value.$validate();
  if(!isValid){
    const targetElement = document.querySelector(".error");
    targetElement?.scrollIntoView({behavior: "smooth", block: 'center'});

    return;
  }

  closingDisdi.value = true;

  currentDisdi.value.isCompleted = true;
  const success = await disdiService.updateDisdiEntry(currentDisdi.value, ErrorLocationType.disdiMaintenance);

  if(!success){
    closingDisdi.value = false;

    return
  }

  closingDisdi.value = false;

  await router.push("/disdi/exit");
}

onMounted(async ()=>{
  loading.value = true;

  const currentDisdiId = disdiStore.currentDisdiId;
  if(NullOrUndefinedHelper(currentDisdiId)) await router.push("/disdi/login");

  currentDisdi.value = await disdiService.getUncompletedDisdiById(currentDisdiId as string, ErrorLocationType.disdiMaintenance);
  if(NullOrUndefinedHelper(currentDisdi.value)) {
    const returnUrl = window.location.origin + "/disdi/login/" + currentDisdiId;
    await router.push({ path: "/disdi/error", query: { returnUrl: returnUrl } });
    return
  }

  if(currentDisdi.value?.isCompleted) {
    await router.push("/disdi/exit");
    return;
  }

  contextLocation.value = await locationService.getLocationBySecondaryId(currentDisdi.value.locationSecondaryId, ErrorLocationType.disdiMaintenance);

  attachmentUrlList.value = await disdiService.getAttachments(currentDisdiId as string, ErrorLocationType.disdiMaintenance);

  categoryList.value = (await categoryService.getCategories("display", ErrorLocationType.disdiMaintenance))?.map((c) =>{
    c.name = c.title;
    return c;
  });
  loading.value = false;
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", _hoisted_3, _toDisplayString(_unref($t)('disdi.maintenance.title')), 1)
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(Error), {
        errorLoc: _unref(ErrorLocationType).disdiMaintenance
      }, null, 8, ["errorLoc"]),
      _createElementVNode("h4", null, _toDisplayString(_unref($t)('disdi.maintenance.generalInfo')), 1),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _createTextVNode(_toDisplayString(_unref($t)('disdi.maintenance.disdiInfo.location')) + ": ", 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(_unref($t)('popups.disdiDetails.location.name')), 1),
              _createElementVNode("div", null, _toDisplayString(contextLocation.value?.name), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(_unref($t)('popups.disdiDetails.location.group2')), 1),
              _createElementVNode("div", null, _toDisplayString(contextLocation.value?.group2Name), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, _toDisplayString(_unref($t)('popups.disdiDetails.location.group1')), 1),
              _createElementVNode("div", null, _toDisplayString(contextLocation.value?.group1Name), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, _toDisplayString(_unref($t)('popups.disdiDetails.location.CCName')), 1),
              _createElementVNode("div", null, _toDisplayString(contextLocation.value?.controlCenterName), 1)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, _toDisplayString(_unref($t)('popups.disdiDetails.location.phoneNumber')), 1),
              _createElementVNode("div", null, _toDisplayString(contextLocation.value?.contactInfo.phoneNumber ?? ""), 1)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, _toDisplayString(_unref($t)('popups.disdiDetails.location.email')), 1),
              _createElementVNode("div", null, _toDisplayString(contextLocation.value?.email), 1)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, _toDisplayString(_unref($t)('popups.disdiDetails.location.street')), 1),
              _createElementVNode("div", null, _toDisplayString(contextLocation.value?.contactInfo.street) + " " + _toDisplayString(contextLocation.value?.contactInfo.streetNumber), 1)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, _toDisplayString(_unref($t)('popups.disdiDetails.location.city')), 1),
              _createElementVNode("div", null, _toDisplayString(contextLocation.value?.contactInfo.postalCode) + " " + _toDisplayString(contextLocation.value?.contactInfo.city), 1)
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _createTextVNode(_toDisplayString(_unref($t)('disdi.maintenance.disdiInfo.registration')) + ": ", 1),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, _toDisplayString(_unref($t)('popups.disdiDetails.registrationStart')), 1),
              _createElementVNode("div", null, _toDisplayString(_unref(regStartString)), 1)
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, _toDisplayString(_unref($t)('popups.disdiDetails.registrationEnd')), 1),
              _createElementVNode("div", null, _toDisplayString(_unref(regEndString)), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("h4", null, _toDisplayString(_unref($t)('disdi.maintenance.maintainInfo')), 1),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_29, _toDisplayString(_unref($t)('disdi.maintenance.diaryDescription')), 1),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", {
              class: _normalizeClass({ error: validator.value.diaryDescription.$errors.length })
            }, [
              (currentDisdi.value !== null)
                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 0,
                    type: "text",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentDisdi.value.diaryDescription) = $event)),
                    class: "w-full"
                  }, null, 512)), [
                    [_vModelText, currentDisdi.value.diaryDescription]
                  ])
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(validator.value.diaryDescription.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "input-errors",
                  key: error.$uid
                }, [
                  _createElementVNode("div", _hoisted_31, _toDisplayString(error.$message), 1)
                ]))
              }), 128))
            ], 2)
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_32, _toDisplayString(_unref($t)('disdi.maintenance.category')), 1),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", {
              class: _normalizeClass({ error: validator.value.categoryId.$errors.length })
            }, [
              (currentDisdi.value !== null)
                ? (_openBlock(), _createBlock(_unref(Select), {
                    key: 0,
                    selected: currentDisdi.value?.categoryId,
                    options: categoryList.value,
                    mode: "single",
                    onSelectChanged: changeCategoryId
                  }, null, 8, ["selected", "options"]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(validator.value.categoryId.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "input-errors",
                  key: error.$uid
                }, [
                  _createElementVNode("div", _hoisted_34, _toDisplayString(error.$message), 1)
                ]))
              }), 128))
            ], 2)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_36, _toDisplayString(_unref($t)('disdi.maintenance.attachments')), 1),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_37, _toDisplayString(_unref($t)('disdi.maintenance.uploadDescription')), 1),
            _createElementVNode("label", _hoisted_38, [
              _createElementVNode("input", {
                type: "file",
                accept: "image/*",
                multiple: "",
                ref_key: "uploadInput",
                ref: uploadInput,
                onChange: addImageToUploadList,
                style: {"display":"none"}
              }, null, 544),
              _createElementVNode("div", _hoisted_39, _toDisplayString(_unref($t)('disdi.maintenance.uploadButton')), 1)
            ]),
            _hoisted_40,
            _createVNode(Progressbar, {
              class: "mt-6",
              barColor: '#1796C1',
              percentage: uploadPercentage.value
            }, null, 8, ["percentage"]),
            (fileNameList.value?.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                  _createTextVNode(_toDisplayString(_unref($t)('disdi.maintenance.uploadedFiles')) + ": ", 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileNameList.value, (name) => {
                    return (_openBlock(), _createElementBlock("div", { key: name }, _toDisplayString(name), 1))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_42, _toDisplayString(_unref($t)('disdi.maintenance.attachmentsPreview')), 1),
          _withDirectives(_createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_43, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attachmentUrlList.value, (url) => {
                return (_openBlock(), _createElementBlock("div", { key: url }, [
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("button", {
                      class: "primary deleteButton",
                      onClick: ($event: any) => (deleteAttachmentByIndex(url))
                    }, _hoisted_47, 8, _hoisted_45),
                    _createElementVNode("img", {
                      class: "w-full",
                      src: url
                    }, null, 8, _hoisted_48)
                  ])
                ]))
              }), 128))
            ])
          ], 512), [
            [_vShow, !loadingAttachments.value]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_49, [
            _createVNode(LoadingSpinner)
          ], 512), [
            [_vShow, loadingAttachments.value]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_50, [
        _createElementVNode("button", {
          class: "primary ml-auto",
          onClick: closeDisdi,
          disabled: closingDisdi.value
        }, [
          _createVNode(_unref(TextOrSpinner), {
            text: _unref($t)('disdi.maintenance.saveAndClose'),
            spin: closingDisdi.value
          }, null, 8, ["text", "spin"])
        ], 8, _hoisted_51)
      ])
    ], 512), [
      [_vShow, !loading.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_52, [
      _createVNode(LoadingSpinner)
    ], 512), [
      [_vShow, loading.value]
    ])
  ]))
}
}

})